/* 321 Cookie - designer POPUP
   Theme ASSET, loaded from the product Custom Liquid block with:
       <script src="{{ 'cookie-designer.js' | asset_url }}" defer></script>
   Must load AFTER cookie-analytics.js and cookie-feedback.js - deferred scripts
   run in document order, so those two are defined before anything here calls
   into them.

   REWRITTEN 2026-08-25. The designer used to render inline in the product
   column, which meant nine controls competing for a narrow space and a lot of
   scrolling. It is now a modal driven by a small state machine:

       stage        what the body shows            what the footer button says
       ----------   ----------------------------   ---------------------------
       start        "How do you want to start?"    Create my design (disabled)
       input        the chosen input panel         Create my design
       analyzing    cookie loader, photo hidden    Reading your photo...
       generating   cookie loader                  Making your design...
       result       stamp + baked cookie + vote    Add to cart - $X

   Two rules run through all of it:
     * never ask a question we can answer ourselves (the style is CLASSIFIED and
       then shown for correction, not asked up front), and
     * never show a control until it matters (the style row does not exist until
       there is a photo or a sentence to classify).

   The network layer is unchanged from the inline version: same /api/generate,
   same multipart upload shape, same /api/classify, same cart properties. Only
   the DOM it paints into moved.
*/
(function () {
  'use strict';

  var root = document.querySelector('.cd-root');
  if (!root) return;

  // ---- side-cars (cookie-analytics.js / cookie-feedback.js) ------------------
  // Both optional. A blocked request, an ad blocker or a missing asset must
  // never take the designer down, so every call goes through these guards and
  // returns null instead of throwing.
  function CA(fn, a, b) {
    try {
      var A = window.CookieAnalytics;
      if (A && typeof A[fn] === 'function') return A[fn](a, b);
    } catch (e) {}
    return null;
  }
  function sessionId() {
    try { return (window.CookieAnalytics && window.CookieAnalytics.sessionId) || ''; }
    catch (e) { return ''; }
  }
  // Re-attaching the SAME design would wipe a vote panel the customer already
  // has open (attach() clears the mount), and select() runs again when the
  // baked-cookie render finishes. So only attach on an actual design change.
  var lastFeedbackId = null;
  function CFB(designId, s) {
    try {
      if (window.CookieFeedback && designId && designId !== lastFeedbackId) {
        lastFeedbackId = designId;
        window.CookieFeedback.attach(designId, s);
      }
    } catch (e) {}
  }

  // ---- config from the Liquid block -----------------------------------------
  var d = root.dataset;
  var endpoint = d.endpoint;
  var classifyEndpoint = (d.classifyEndpoint || '') ||
                         endpoint.replace(/\/generate\b/, '/classify');
  var freeLimit = parseInt(d.freeLimit || '0', 10);      // 0 = unlimited
  var priceLabel = d.price || '';
  var pageMode = (d.mode === 'modify' || d.mode === 'personalize') ? d.mode : 'design';
  var baseDesign = d.baseDesign || '';
  var baseUrl = d.baseUrl || '';
  var baseTitle = d.baseTitle || 'this design';
  // What the change panel redraws. On a ready-made page it starts as the page's
  // own design; "Change something" under a finished design points it at THAT
  // design instead (09-23, Mike: let customers add a hat or sunglasses to the
  // picture they already have, rather than starting over).
  var pageBase = { id: baseDesign, url: baseUrl, title: baseTitle, style: d.style || '', own: false };
  var modBase = pageBase;
  var customVariant = d.customVariant || '';
  // Free personalize (2026-10-01): set = a name on a ready-made carts as this
  // variant (same price as the design). Blank = custom variant as before.
  var personalizeVariant = d.personalizeVariant || '';
  var personalizePrice = d.personalizePrice || '';

  // ---- packs (Business Logo Stamp, 2026-09-18) --------------------------------
  // A pack is a variant that prints several copies of ONE design: 1 / 3 / 6 / 12.
  // The chooser sits above Add to cart and IS the variant this popup carts;
  // the page's own variant picker only seeds it (via ?variant=). Default is
  // the 6-pack, the offer the page leads with.
  var packs = [];
  try { packs = JSON.parse(d.packs || '[]') || []; } catch (e) { packs = []; }
  var packMode = packs.length > 1 && pageMode === 'design';
  var pack = null;
  if (packMode) {
    var pm = window.location.search.match(/[?&]variant=(\d+)/);
    packs.forEach(function (p) { if (pm && String(p.id) === pm[1]) pack = p; });
    if (!pack) packs.forEach(function (p) { if (!pack && Number(p.discs) === 6) pack = p; });
    if (!pack) pack = packs[0];
  }
  function priceNow() {
    if (mode === 'personalize' && personalizeVariant && personalizePrice) return personalizePrice;
    return packMode && pack ? pack.price : priceLabel;
  }

  // ---- personalized (monogram) stamps, added 2026-09-18 -----------------------
  // Curved words around a picture, set from a font by the backend
  // ({"monogram": {...}} on /api/generate, see stamp-ai-backend api/monogram.py).
  // Two ways in: a personalized PRODUCT (cookie.monogram_art_id = the picture,
  // monogram_top = its default greeting) opens straight on the words panel, and
  // any design in the tray gets an "Add words around it" button.
  // A ready-made page (pageMode 'modify') personalizes its OWN design.
  var monoProduct = d.monoArt ? { art_id: d.monoArt, url: d.monoArtUrl || '',
                                  title: baseTitle, from: baseTitle }
                  : (pageMode === 'modify' && baseDesign)
                    ? { art_id: baseDesign, url: baseUrl, title: baseTitle, from: baseTitle }
                    : null;
  var monoBase = monoProduct;            // the picture the words panel is working on
  var MONO_MSGS = ['Setting your letters…', 'Curving them round…', 'Checking they’ll carve cleanly…'];

  // Tile id -> what the customer sees, and what goes on the wire.
  // 'text' and 'logo' are the SAME backend style today; they differ only in
  // which product offers them and what we say about them. Splitting the
  // backend is Layer 3 of claude/logo-split-implementation-2026-09-18.md and
  // is not required for this to work. Renaming a label is a copy change only.
  var TILES = {
    portrait: { wire: 'portrait', label: 'Headshot',      hint: 'Keeps their real features and expression.' },
    scene:    { wire: 'scene',    label: 'Full body',     hint: 'Head to toe, or a little scene.' },
    object:   { wire: 'object',   label: 'Single thing',  hint: 'One clean object, with no face added.' },
    text:     { wire: 'graphic',  label: 'Words',         hint: 'A name, a message or initials — think "Merry Christmas".' },
    logo:     { wire: 'graphic',  label: 'Business logo', hint: 'Your mark, cleaned up so it reads at 3 inches.' }
  };
  var DEFAULT_TILES = ['portrait', 'scene', 'object', 'text'];
  var WIRE_STYLES = ['portrait', 'scene', 'object', 'graphic'];

  // Which tiles THIS product offers - custom.designer_styles, e.g. 'logo' on
  // the business product. Blank or junk falls back to the consumer four.
  var allowed = (d.styles || '').split(',')
    .map(function (s) { return s.trim().toLowerCase(); })
    .filter(function (s, i, a) { return TILES[s] && a.indexOf(s) === i; });
  if (!allowed.length) allowed = DEFAULT_TILES;
  // One tile is not a choice: hide the row, the product subtext carries it.
  var singleTile = allowed.length === 1;

  // Anything -> a WIRE style ('' if unknown). Accepts tile ids and aliases.
  function normStyle(s) {
    s = (s || '').trim().toLowerCase();
    if (s === 'living') s = 'portrait';                  // backend aliases
    if (s === 'logo' || s === 'monogram' || s === 'text') s = 'graphic';
    return WIRE_STYLES.indexOf(s) >= 0 ? s : '';
  }
  // Anything -> a tile THIS product offers. Never returns nothing: a style the
  // page does not offer (classifier said 'portrait' on the logo page, or a
  // future wire style with no tile here) lands on the first allowed tile, so
  // the row can never end up with zero tiles pressed.
  function resolveTile(s) {
    var k = (s || '').trim().toLowerCase();
    if (allowed.indexOf(k) >= 0) return k;
    var wire = normStyle(k);
    for (var i = 0; i < allowed.length; i++) {
      if (TILES[allowed[i]].wire === wire) return allowed[i];
    }
    return allowed[0];
  }
  function tileLabel(k) { return TILES[k] ? TILES[k].label : ''; }
  // Label for a finished design: its own tile if it has one, else the tile its
  // wire style maps to on this page (older session records carry only style).
  function designLabel(x) {
    return tileLabel(x.tile) || (x.style ? tileLabel(resolveTile(x.style)) : '');
  }
  function seedTile() { return resolveTile(d.style || d.defaultStyle || ''); }

  var tile = seedTile();
  var style = TILES[tile].wire;          // what goes on the wire

  // ---- "Is this for a business?" (Layer 2 of the logo split) ----------------
  // An OFFER, never a redirect: detection is a keyword and a model guess, and
  // "Grandma's Bakery, est. 1974" on a birthday cookie is not a business. Shown
  // at most once per session, only on products that do not already offer the
  // logo tile, and only when the customer presses Create.
  var BIZ_URL = '/products/custom-business-logo-cookie-stamp';
  var BIZ_RE = /\b(logo|logotype|wordmark|brand|business|company|llc|inc|bakery|bakeshop|caf[eé]|coffee ?shop|restaurant|food ?truck|catering|our (shop|store|brand|logo|company|bakery))\b/i;
  var BIZ_SEEN_KEY = 'cd_biz_offer_seen';
  var bizEligible = allowed.indexOf('logo') === -1;
  var lastClassGraphic = false;          // the CLASSIFIER said graphic, not a tap
  function bizSeen() { try { return sessionStorage.getItem(BIZ_SEEN_KEY) === '1'; } catch (e) { return false; } }
  function markBizSeen() { try { sessionStorage.setItem(BIZ_SEEN_KEY, '1'); } catch (e) {} }

  var PHOTO_MSGS = ['Taking a look at your photo…', 'Finding the subject…',
                    'Checking it will carve cleanly…'];
  var GEN_MSGS = ['Rolling out the dough…', 'Drawing your design…',
                  'Cleaning up the lines…', 'Pressing it into a cookie…'];

  // How long each loading line stays up. Was 900-950ms, which read as a flicker
  // rather than something to read.
  var MSG_EVERY_MS = 2400;
  // The baked-cookie image is a second server call. We hold the loading screen
  // until it lands so the customer gets both pictures at once - but never longer
  // than this, or a slow cookie would trap them on a spinner with a design that
  // is already finished.
  var COOKIE_WAIT_MS = 30000;

  var MAX_UPLOAD_BYTES = 15 * 1024 * 1024;   // keep in step with the server cap
  // Vercel hard-rejects a body over ~4.5 MB with a 413 BEFORE our code runs,
  // which used to surface as a bogus "Network error" for anyone sending a big
  // phone photo. Downscale first. The design is thresholded to B/W line art
  // anyway, so ~1600px on the long edge keeps every detail that matters.
  var UPLOAD_MAX_EDGE = 1600;
  var UPLOAD_JPEG_QUALITY = 0.85;
  var UPLOAD_TARGET_BYTES = 4 * 1024 * 1024;

  // ---- elements --------------------------------------------------------------
  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  var modal      = q('.cd-modal');
  var sheet      = q('.cd-sheet');
  var body       = q('.cd-body');
  var secStart   = q('.cd-sec-start');
  var modebar    = q('.cd-modebar');
  var panDesc    = q('.cd-pan-describe');
  var panUpload  = q('.cd-pan-upload');
  var panModify  = q('.cd-pan-modify');
  var styleBlock = q('.cd-styleblock');
  var stylesRow  = q('.cd-styles');
  var detectedEl = q('.cd-detected');
  var secGen     = q('.cd-sec-gen');
  var secResult  = q('.cd-sec-result');
  var promptEl   = q('.cd-prompt');
  var noteEl     = q('.cd-note');
  var modnoteEl  = q('.cd-modnote');
  var fileEl     = q('.cd-file');
  var photoWrap  = q('.cd-photoframe');
  var photoImg   = q('.cd-photo');
  var photoLoad  = q('.cd-photoloading');
  var photoMsg   = q('.cd-photoloading .cd-loadmsg');
  var changeBtn  = q('.cd-changephoto');
  var genMsg     = q('.cd-genmsg');
  var artImg     = q('.cd-art');
  var cookieImg  = q('.cd-cookieimg');
  var stampFig   = q('.cd-fig-stamp');
  var cookieFig  = q('.cd-fig-cookie');
  var capStyle   = q('.cd-cap-style');
  var editTxt    = q('.cd-edittxt');
  var editBtn    = q('.cd-editbtn');
  var tray       = q('.cd-tray');
  var thumbsEl   = q('.cd-thumbs');
  var newTile    = q('.cd-newtile');
  var hintEl     = q('.cd-hint');
  var primary    = q('.cd-primary');
  var secondary  = q('.cd-secondary');
  var closeBtn   = q('.cd-x');
  var baseImg    = q('.cd-baseimg');
  var baseName   = q('.cd-basename');
  var baseNote   = q('.cd-basemeta small');
  var baseNoteDefault = baseNote ? baseNote.textContent : '';
  var modExamplesDefault = (q('.cd-modexamples') || {}).innerHTML || '';
  var OWN_CHIPS = ['add sunglasses', 'give it a party hat', 'add a bow tie'];
  // Changing their own design: a way back to it without making anything.
  var modBackBtn = null;
  if (panModify) {
    modBackBtn = document.createElement('button');
    modBackBtn.type = 'button';
    modBackBtn.className = 'cd-link cd-monoback';
    modBackBtn.hidden = true;
    modBackBtn.textContent = '← Back to your design';
    panModify.insertBefore(modBackBtn, panModify.firstChild);
  }
  // Names and words: the image model places lettering badly (on the 09-23 bench
  // "add the name BEA" landed on the dog's paws), while "Add words around it"
  // sets exact curved letters for free. When the change asks for words, point
  // there - a suggestion only; they can still create the version.
  var nameTip = null;
  if (panModify) {
    nameTip = document.createElement('p');
    nameTip.className = 'cd-nametip';
    nameTip.hidden = true;
    nameTip.innerHTML = 'Adding a name or words? We can set your exact letters in curved type ' +
      'around the picture instead, free. <button type="button" class="cd-link">Add words instead →</button>';
    panModify.appendChild(nameTip);
  }
  var NAME_RE = /\b(names?|named|initials?|monogram|words?|text|letters?|lettering|says?|saying|write|written|spell|spelled|happy birthday|merry christmas|congrat\w*)\b|["“”]/i;
  // The words to pre-fill: quoted text, else capitals like BEA, else the word
  // after "name"/"named". Uppercased and trimmed to what the words step accepts.
  function guessWords(t) {
    var m = t.match(/["“”‘’']([^"“”‘’']{1,24})["“”‘’']/) ||
            t.match(/\b([A-Z][A-Z0-9&'.\- ]*[A-Z0-9])\b/) ||
            t.match(/\bnamed?\s+([A-Za-z][A-Za-z'\-]*)/i);
    var w = m ? m[1] : '';
    return w.toUpperCase().replace(/[^A-Z0-9 &'.\-]/g, '').trim().slice(0, 24);
  }
  function checkNameTip() {
    if (!nameTip) return;
    nameTip.hidden = !(panPersonal && mode === 'modify' && stage === 'input' &&
                       NAME_RE.test((modnoteEl && modnoteEl.value) || ''));
  }
  var stepEls    = qa('.cd-st');

  // The business offer is built here rather than in the Liquid snippet, so it
  // ships with this file alone. Colours come from the snippet's --cd-* palette.
  var bizEl = null;
  if (bizEligible && body) {
    bizEl = document.createElement('section');
    bizEl.className = 'cd-biz';
    bizEl.hidden = true;
    bizEl.innerHTML =
      '<h3 class="cd-q">Is this for a business?</h3>' +
      '<p class="cd-biz-p">If you’re pressing your own mark into cookies you sell, the ' +
      '<b>Business Logo Stamp</b> is built for it — we clean your artwork up so it reads ' +
      'at 3 inches, and it covers commercial use. It is $14.99 a stamp, and 3 or more ' +
      'take 15% to 45% off automatically.</p>' +
      '<div class="cd-biz-btns">' +
      '<button type="button" class="cd-biz-go">Show me the business stamp →</button>' +
      '<button type="button" class="cd-biz-no"></button>' +
      '</div>';
    body.appendChild(bizEl);
    var bizCss = document.createElement('style');
    bizCss.textContent =
      '.cd-biz{display:flex;flex-direction:column;gap:.6rem}' +
      '.cd-biz[hidden]{display:none}' +
      '.cd-biz-p{margin:0;font-size:.9rem;line-height:1.45;color:var(--cd-body)}' +
      '.cd-biz-btns{display:flex;flex-direction:column;gap:.5rem;margin-top:.3rem}' +
      '.cd-biz-go{border:0;background:var(--cd-accent);color:var(--cd-accent-ink);border-radius:12px;' +
        'padding:.8rem 1rem;font:inherit;font-weight:700;cursor:pointer}' +
      '.cd-biz-no{border:1.5px solid var(--cd-line2);background:var(--cd-surface);color:var(--cd-ink);' +
        'border-radius:12px;padding:.75rem 1rem;font:inherit;font-weight:600;cursor:pointer}';
    root.appendChild(bizCss);
  }

  // The words panel, the spelling check and the "add words" button are built
  // here for the same reason as the business offer: they ship with this file.
  var panPersonal = null, monoTopEl = null, monoBotEl = null, monoImg = null,
      monoName = null, monoConfirm = null, monoOk = null, addWordsBtn = null,
      changeItBtn = null, packEl = null;
  if (body && secResult) {
    panPersonal = document.createElement('section');
    panPersonal.className = 'cd-pan-personal';
    panPersonal.hidden = true;
    panPersonal.innerHTML =
      '<button type="button" class="cd-link cd-monoback" hidden>\u2190 Back to your design</button>' +
      '<h3 class="cd-q">Make it yours</h3>' +
      '<div class="cd-basewrap">' +
        '<figure class="cd-baseframe"><img class="cd-monoimg" width="78" height="78" alt="The picture in the middle of your stamp"></figure>' +
        '<div class="cd-basemeta"><b class="cd-mononame"></b>' +
        '<small>We set your words in curved capital letters around the picture, spelled exactly as you type them.</small></div>' +
      '</div>' +
      '<label class="cd-lab" for="cd-monotop">Top line</label>' +
      '<input class="cd-in cd-monotop" id="cd-monotop" type="text" maxlength="24" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="MERRY CHRISTMAS">' +
      '<label class="cd-lab" for="cd-monobot">Bottom line</label>' +
      '<input class="cd-in cd-monobot" id="cd-monobot" type="text" maxlength="24" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="THE SMITHS">' +
      '<p class="cd-mononote">Capital letters, numbers, spaces and &amp; \' . - only. About 15 letters fit on each line. Leave a line empty to skip it.</p>' +
      '<p class="cd-mononote cd-monoprice" hidden></p>';
    body.appendChild(panPersonal);
    monoTopEl = panPersonal.querySelector('.cd-monotop');
    monoBotEl = panPersonal.querySelector('.cd-monobot');
    monoImg = panPersonal.querySelector('.cd-monoimg');
    monoName = panPersonal.querySelector('.cd-mononame');

    var fb = secResult.querySelector('#cd-feedback');
    monoConfirm = document.createElement('label');
    monoConfirm.className = 'cd-monoconfirm';
    monoConfirm.hidden = true;
    monoConfirm.innerHTML = '<input type="checkbox" class="cd-monook"> ' +
      '<span>I’ve checked the spelling. Carve it exactly as shown.</span>';
    // In the FOOTER, directly above Add to cart: it is what holds that button
    // back, so it sits where the customer is looking when the button will not go.
    if (primary && primary.parentNode) primary.parentNode.insertBefore(monoConfirm, primary);
    else secResult.insertBefore(monoConfirm, fb);
    monoOk = monoConfirm.querySelector('.cd-monook');

    if (packMode) {
      packEl = document.createElement('fieldset');
      packEl.className = 'cd-packs';
      packEl.hidden = true;
      packEl.innerHTML = '<legend class="cd-packs-q">How many stamps?</legend>' +
        packs.map(function (p) {
          var n = Number(p.discs) || 1;
          var each = n > 1 ? ' · $' + (p.cents / n / 100).toFixed(2) + ' ea' : '';
          return '<button type="button" class="cd-pack" data-id="' + p.id + '"' +
            (p.available === false ? ' disabled' : '') + '>' +
            '<b>' + n + (n === 1 ? ' stamp' : ' stamps') + '</b>' +
            '<small>' + p.price + each + '</small></button>';
        }).join('') +
        '<p class="cd-packs-note">Every stamp in a pack is this design. ' +
        'More stamps, faster trays: each one stays on its cookie while it chills.</p>';
      if (primary && primary.parentNode) primary.parentNode.insertBefore(packEl, primary);
      else secResult.insertBefore(packEl, fb);
      packEl.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('.cd-pack') : null;
        if (!b || b.disabled) return;
        packs.forEach(function (p) { if (String(p.id) === b.getAttribute('data-id')) pack = p; });
        paintPacks();
        render();
      });
      paintPacks();
    }

    addWordsBtn = document.createElement('button');
    addWordsBtn.type = 'button';
    addWordsBtn.className = 'cd-link cd-addwords';
    addWordsBtn.hidden = true;
    addWordsBtn.textContent = '+ Add words around it, like a family name';
    secResult.insertBefore(addWordsBtn, fb);

    changeItBtn = document.createElement('button');
    changeItBtn.type = 'button';
    changeItBtn.className = 'cd-link cd-changeit';
    changeItBtn.hidden = true;
    changeItBtn.textContent = '\u270e Change something, like adding a hat or sunglasses';
    secResult.insertBefore(changeItBtn, addWordsBtn);

    var monoCss = document.createElement('style');
    monoCss.textContent =
      '.cd-pan-personal[hidden],.cd-monoconfirm[hidden],.cd-addwords[hidden],' +
        '.cd-changeit[hidden],.cd-monoback[hidden]{display:none}' +
      '.cd-monoback{align-self:flex-start;margin:0 0 .4rem;padding-left:0}' +
      '.cd-changeit{align-self:center}' +
      '.cd-nametip[hidden]{display:none}' +
      '.cd-nametip{margin:.7rem 0 0;padding:.55rem .7rem;border-radius:10px;background:var(--cd-accent-soft);' +
        'font-size:.82rem;line-height:1.4;color:var(--cd-ink)}' +
      '.cd-nametip .cd-link{padding:0 .1rem;font-size:.82rem}' +
      '.cd-pan-personal .cd-lab{margin-top:.8rem}' +
      '.cd-in{width:100%;box-sizing:border-box;border:1.5px solid var(--cd-line2);border-radius:12px;' +
        'padding:.7rem .85rem;font:inherit;font-size:1rem;letter-spacing:.05em;text-transform:uppercase;' +
        'background:var(--cd-surface);color:var(--cd-ink)}' +
      '.cd-in:focus{border-color:var(--cd-accent);outline:none}' +
      '.cd-mononote{margin:.6rem 0 0;font-size:.78rem;line-height:1.4;color:var(--cd-muted)}' +
      '.cd-monoconfirm{display:flex;gap:.6rem;align-items:center;font-size:.9rem;line-height:1.35;' +
        'color:var(--cd-ink);background:var(--cd-surface2);border:2px solid var(--cd-line2);' +
        'border-radius:12px;padding:.6rem .8rem;cursor:pointer;transition:background .2s,border-color .2s}' +
      '.cd-monoconfirm input{margin:0;width:1.3rem;height:1.3rem;flex:0 0 auto;accent-color:var(--cd-accent);cursor:pointer}' +
      /* not ticked yet: this is the thing standing between them and the cart */
      '.cd-monoconfirm.cd-todo{border-color:var(--cd-accent);background:var(--cd-accent-soft);font-weight:700}' +
      '.cd-addwords{align-self:center}' +
      '.cd-monoresult .cd-pair{grid-template-columns:minmax(0,1fr);justify-items:center}' +
      '.cd-packs[hidden]{display:none}' +
      '.cd-packs{border:0;margin:0 0 .6rem;padding:0;display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:.4rem}' +
      '.cd-packs-q{padding:0;margin:0 0 .35rem;font-size:.85rem;font-weight:700;color:var(--cd-ink)}' +
      '.cd-pack{display:flex;flex-direction:column;align-items:center;gap:.1rem;min-width:0;padding:.5rem .3rem;' +
        'border:1.5px solid var(--cd-line2);border-radius:12px;background:var(--cd-surface);color:var(--cd-ink);' +
        'font:inherit;cursor:pointer;text-align:center}' +
      '.cd-pack b{font-size:.88rem}' +
      '.cd-pack small{font-size:.72rem;line-height:1.25;color:var(--cd-muted)}' +
      '.cd-pack[aria-pressed="true"]{border-color:var(--cd-accent);background:var(--cd-accent-soft);border-width:2px}' +
      '.cd-pack:disabled{opacity:.45;cursor:not-allowed}' +
      '.cd-packs-note{grid-column:1/-1;margin:.15rem 0 0;font-size:.74rem;line-height:1.35;color:var(--cd-muted)}' +
      '@media (max-width:420px){.cd-packs{grid-template-columns:repeat(2,minmax(0,1fr))}}';
    root.appendChild(monoCss);
  }

  function paintPacks() {
    if (!packEl) return;
    [].forEach.call(packEl.querySelectorAll('.cd-pack'), function (b) {
      b.setAttribute('aria-pressed', pack && String(pack.id) === b.getAttribute('data-id') ? 'true' : 'false');
    });
  }

  // Keep only what the stamp can carve, in capitals, as they type. The server
  // checks again; this just stops the error arriving after a 1-second wait.
  function monoTidy(el) {
    var v = el.value;
    var up = v.toUpperCase().replace(/[‘’]/g, "'").replace(/[–—]/g, '-');
    var ok = up.replace(/[^A-Z0-9 &'.\-]/g, '');
    if (ok === v) return;
    var p = el.selectionStart == null ? ok.length : el.selectionStart - (up.length - ok.length);
    el.value = ok;
    try { el.setSelectionRange(Math.max(0, p), Math.max(0, p)); } catch (e) {}
    if (up.length !== ok.length) hint('Letters, numbers, spaces and & \' . - only.', 'err');
  }
  [monoTopEl, monoBotEl].forEach(function (el) {
    if (!el) return;
    el.addEventListener('input', function () { hint(''); monoTidy(el); render(); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); go(); }
    });
  });

  // ---- state -----------------------------------------------------------------
  var mode = null;              // describe | upload | modify
  var stage = 'start';          // start | input | analyzing | generating | result
  var styleTouched = false;     // a hand-picked style outranks the suggestion
  var photoState = 'none';      // none | loading | ready
  var pendingFile = null;
  var photoURL = null;
  var designs = [];             // [{design_id, design_url, preview_b64, cookie_*, style, label, from}]
  var selected = -1;
  // Each page shows only the designs that belong to ITS product. The tray is
  // the whole session and follows the customer between pages, so without this
  // a headshot made on the $17.99 Custom Cookie Stamp could be picked on the
  // Business Logo page and carted as a logo pack - or a logo carted at the
  // consumer price (Mike, 2026-09-18). Nothing is deleted: a design reappears
  // on the page it was made for.
  var logoPage = allowed.indexOf('logo') >= 0;
  function onThisPage(x) { return !!x && (x.tile === 'logo') === logoPage; }
  function lastOnThisPage() {
    for (var i = designs.length - 1; i >= 0; i--) if (onThisPage(designs[i])) return i;
    return -1;
  }
  var addedCounts = {};
  var opened = false;           // has the modal been opened this page-load
  var timers = [];

  function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }

  // ---- soft cap + persistence (unchanged behaviour) --------------------------
  var COUNT_KEY = 'cd_gen_count';
  function genCount() { try { return parseInt(localStorage.getItem(COUNT_KEY) || '0', 10); } catch (e) { return 0; } }
  function bumpCount() { try { localStorage.setItem(COUNT_KEY, String(genCount() + 1)); } catch (e) {} }
  function capReached() { return freeLimit > 0 && genCount() >= freeLimit; }

  // Keep the session's designs across page navigations. Store lightweight
  // records (URLs, not the big base64 blobs). Keyed on the DESIGNER product, not
  // location.pathname, so a design made from a ready-made page is still there
  // when the customer wanders to another product.
  var STORE_KEY = 'cd_designs:v2';
  function persist() {
    try {
      var slim = designs.map(function (x) {
        return { design_id: x.design_id, design_url: x.design_url,
                 cookie_url: x.cookie_url || null, style: x.style || '',
                 tile: x.tile || '', label: x.label || '', from: x.from || '',
                 mono: x.mono || null,
                 origin: x.origin ? { mode: x.origin.mode, prompt: x.origin.prompt || '',
                                      note: x.origin.note || '', base: x.origin.base || null } : null };
      });
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ v: 2, designs: slim, counts: addedCounts }));
    } catch (e) { /* storage blocked or full -> skip persistence */ }
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || !Array.isArray(data.designs)) return;
      designs = data.designs.filter(function (x) { return x && x.design_id; })
        .map(function (x) {
          return { design_id: x.design_id, design_url: x.design_url,
                   preview_b64: null, cookie_b64: null,
                   cookie_url: x.cookie_url || null, style: x.style || '',
                   tile: x.tile || '', label: x.label || '', from: x.from || '',
                   mono: x.mono || null, origin: x.origin || null };
        });
      addedCounts = (data.counts && typeof data.counts === 'object') ? data.counts : {};
      selected = lastOnThisPage();
      renderTray();
    } catch (e) { /* ignore corrupt storage */ }
  }

  function designSrc(x) {
    return x.preview_b64 ? ('data:image/png;base64,' + x.preview_b64) : (x.design_url || '');
  }
  function cookieSrc(x) {
    return x.cookie_b64 ? ('data:image/png;base64,' + x.cookie_b64) : (x.cookie_url || '');
  }
  function figLoading(fig, on) { if (fig) fig.classList.toggle('cd-loading', !!on); }
  function setImg(img, fig, src) {
    if (!img) return;
    if (!src) { img.removeAttribute('src'); figLoading(fig, false); return; }
    if (src.indexOf('data:') === 0) {
      figLoading(fig, false);
      img.onload = null; img.onerror = null;
      img.src = src;
    } else {
      figLoading(fig, true);
      img.onload = function () { figLoading(fig, false); };
      img.onerror = function () { figLoading(fig, false); };
      img.src = src;
    }
  }

  function hint(msg, kind) {
    if (!hintEl) return;
    hintEl.textContent = msg || '';
    hintEl.className = 'cd-hint' + (kind ? ' cd-' + kind : '');
  }

  // ---- style tiles -----------------------------------------------------------
  function escAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }
  stylesRow.innerHTML = allowed.map(function (k) {
    // text/logo borrow the old graphic art until their own PNG is on the theme
    var src = d['tile' + k.charAt(0).toUpperCase() + k.slice(1)] ||
              (TILES[k].wire === 'graphic' ? d.tileGraphic : '') || '';
    return '<button class="cd-tile" type="button" data-tile="' + k +
           '" aria-pressed="false" title="' + escAttr(TILES[k].hint) + '">' +
           (src ? '<img src="' + src + '" alt="">' : '') +
           '<span class="cd-nm">' + TILES[k].label + '</span></button>';
  }).join('');
  // Fewer tiles than the default four: size the grid to what is there.
  if (allowed.length !== 4) stylesRow.style.gridTemplateColumns = 'repeat(' + allowed.length + ',1fr)';
  if (singleTile) stylesRow.hidden = true;

  // Takes a tile id OR a wire style, and always leaves exactly one tile pressed.
  function setStyle(s) {
    tile = resolveTile(s);
    style = TILES[tile].wire;
    qa('.cd-tile').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.tile === tile));
    });
  }
  setStyle(tile);

  // With one tile there is nothing to pick, so the whole style block stays shut.
  function showStyleBlock(on) { show(styleBlock, !!on && !singleTile); }

  stylesRow.addEventListener('click', function (e) {
    var b = e.target.closest('.cd-tile');
    if (!b) return;
    styleTouched = true;                     // a deliberate choice outranks the suggestion
    setStyle(b.dataset.tile);
    detectedEl.innerHTML = 'You picked <b>' + tileLabel(tile) + '</b>. We’ll draw it that way.';
    CA('styleSelected', style);              // wire style, so reports keep grouping the same
  });

  // ---- classify: answer the style question instead of asking it --------------
  // ALWAYS resolves. A classifier problem must never leave a dead button.
  function classifyInput(opts) {
    var payload;
    var prep = Promise.resolve();
    if (opts.file) {
      prep = downscaleImage(opts.file).then(function (blob) {
        payload = new FormData();
        payload.append('image', blob, opts.file.name || 'upload');
      });
    } else {
      payload = new FormData();
      payload.append('prompt', opts.prompt || '');
    }
    return prep.then(function () {
      return fetch(classifyEndpoint, { method: 'POST', body: payload });
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || !res.ok) return { ok: false, error: res && res.error };
      lastClassGraphic = normStyle(res.category) === 'graphic';
      // never auto-select 'finished' - a wrong one yields a blob
      if (!styleTouched && res.category && res.category !== 'finished') {
        setStyle(res.category);
      }
      showDetected(res, !!opts.file);
      return res;
    }).catch(function () {
      return { ok: true, category: style, label: 'your selection', certain: false };
    });
  }
  function showDetected(res, fromPhoto) {
    if (!detectedEl) return;
    // "as a Words" did not read, so the label sits in a "<b>X</b> style" frame
    var lead = fromPhoto ? 'We looked at your photo — we’ll use the '
                         : 'From what you wrote, we’ll use the ';
    detectedEl.innerHTML = lead + '<b>' + (tileLabel(tile) || 'best') +
                           '</b> style. Not right? Tap another.';
  }

  // ---- open / close ----------------------------------------------------------
  function show(el, on) { if (el) el.hidden = !on; }

  function openModal(which) {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';   // don't scroll the page behind
    if (!opened) { opened = true; CA('designerOpened', { entry: which || pageMode }); }
    clearTimers();
    if (which === 'modify') {
      startModify(pageBase, null);
    } else if (which === 'personalize' && monoProduct) {
      startPersonalize(monoProduct, { top: d.monoTop || '', bottom: '' });
    } else if (stage === 'result' && onThisPage(designs[selected])) {
      showResult();
    } else {
      later(function () { var f = q('.cd-modecard'); if (f) f.focus(); }, 40);
      render();
    }
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    clearTimers();
    // Closing KEEPS the session: reopening brings the designs back. What we do
    // want to know is whether they left without ever making one.
    if (!designs.length) CA('designerAbandoned', { stage: stage, mode: mode });
  }

  document.querySelectorAll('[data-cd-open]').forEach(function (b) {
    b.addEventListener('click', function () { openModal(b.getAttribute('data-cd-open') || ''); });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab') trapFocus(e);
  });
  function trapFocus(e) {
    var f = qa('.cd-sheet button, .cd-sheet textarea, .cd-sheet input, .cd-sheet a[href]')
      .filter(function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ---- stages ----------------------------------------------------------------
  var STEP_LABELS = {
    design: ['Start', 'Style', 'Your design'],
    modify: ['Base', 'Change', 'Your version'],
    personalize: ['Picture', 'Words', 'Your stamp']
  };
  function setStepLabels(kind) {
    var L = STEP_LABELS[kind] || STEP_LABELS.design;
    qa('.cd-st .cd-lb').forEach(function (el, i) { el.textContent = L[i]; });
  }
  function setStep(n) {
    stepEls.forEach(function (el) {
      el.classList.toggle('cd-on', parseInt(el.dataset.s, 10) <= n);
    });
  }

  function hideAllPanels() {
    [secStart, modebar, panDesc, panUpload, panModify, panPersonal, styleBlock, secGen, secResult, bizEl, monoConfirm, packEl]
      .forEach(function (el) { show(el, false); });
  }

  // Back to the start question with a clean slate. The tray is NEVER cleared -
  // it is the session, and losing it would defeat the point of having one.
  function startFresh() {
    clearTimers();
    mode = null; stage = 'start'; styleTouched = false;
    photoState = 'none'; pendingFile = null;
    if (photoURL) { try { URL.revokeObjectURL(photoURL); } catch (e) {} photoURL = null; }
    if (promptEl) promptEl.value = '';
    if (noteEl) noteEl.value = '';
    if (modnoteEl) modnoteEl.value = '';
    if (fileEl) fileEl.value = '';
    if (photoImg) photoImg.removeAttribute('src');
    show(photoWrap, false); show(photoLoad, false); show(changeBtn, false);
    lastGuessed = '';
    lastClassGraphic = false;
    setStyle(seedTile());
    setStepLabels('design');
    hideAllPanels();
    show(secStart, true);
    if (body) body.scrollTop = 0;
    render();
  }

  function setMode(m) {
    mode = m;
    stage = 'input';
    setStepLabels('design');
    hideAllPanels();
    show(modebar, true);
    modebar.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.mode === m));
    });
    show(panDesc, m === 'describe');
    show(panUpload, m === 'upload');
    showStyleBlock(m === 'describe'
      ? (promptEl.value || '').trim().split(/\s+/).filter(Boolean).length >= 2
      : photoState === 'ready');
    if (m === 'describe') later(function () { promptEl.focus(); }, 30);
    render();
  }

  // Modify skips the start question entirely: the base design and the style are
  // both inherited, so the only thing left to ask is what to change. `base` is
  // the page's ready-made (pageBase) or a design the customer made (own: true);
  // null keeps the current one. `note` pre-fills the box (an Edit); null leaves it.
  function startModify(base, note) {
    clearTimers();
    if (base) modBase = base;
    mode = 'modify';
    stage = 'input';
    setStepLabels('modify');
    hideAllPanels();
    show(panModify, true);
    if (baseImg) { if (modBase.url) baseImg.src = modBase.url; else baseImg.removeAttribute('src'); }
    if (baseName) baseName.textContent = modBase.own ? 'Changing your design' : 'Starting from ' + modBase.title;
    if (baseNote) baseNote.textContent = modBase.own
      ? 'We redraw your design with just that change, keeping the rest as close as we can.'
      : baseNoteDefault;
    var mx = q('.cd-modexamples');
    if (mx) mx.innerHTML = modBase.own
      ? OWN_CHIPS.map(function (t) { return '<button type="button">' + t + '</button>'; }).join('')
      : modExamplesDefault;
    if (note != null && modnoteEl) modnoteEl.value = note;
    if (modBackBtn) modBackBtn.hidden = !(modBase.own && findDesign(modBase.id) >= 0);
    setStyle(modBase.style || '');
    hint('');
    render();
    later(function () { if (modnoteEl) modnoteEl.focus(); }, 60);
  }

  // A design the customer made, as something to change.
  function ownBase(x) {
    return { id: x.design_id, url: x.design_url || designSrc(x), title: 'your design',
             style: x.tile || x.style || '', own: true };
  }
  // The tray index of a design on this page, or -1.
  function findDesign(id) {
    for (var i = designs.length - 1; i >= 0; i--) {
      if (designs[i].design_id === id && onThisPage(designs[i])) return i;
    }
    return -1;
  }

  // Words panel. `base` is the picture ({art_id, url, title, from}); `vals`
  // pre-fills the two lines (a product's default greeting, or an edit).
  function startPersonalize(base, vals) {
    if (!panPersonal) return;
    clearTimers();
    if (base) monoBase = base;
    if (!monoBase) return;
    mode = 'personalize';
    stage = 'input';
    setStepLabels('personalize');
    hideAllPanels();
    show(panPersonal, true);
    if (vals) { monoTopEl.value = vals.top || ''; monoBotEl.value = vals.bottom || ''; }
    if (monoImg) { if (monoBase.url) monoImg.src = monoBase.url; else monoImg.removeAttribute('src'); }
    if (monoName) monoName.textContent = 'Starting from ' + (monoBase.title || 'your design');
    var mb = panPersonal.querySelector('.cd-monoback');
    if (mb) mb.hidden = findDesign(monoBase.art_id) < 0;
    // On a ready-made page the price changes, so say so before they type.
    var mp = panPersonal.querySelector('.cd-monoprice');
    if (mp) {
      mp.hidden = !(pageMode === 'modify' && priceLabel);
      mp.textContent = 'Personalized stamps are made to order as custom stamps (' + priceLabel + '), so we remake or refund them if they arrive damaged or print wrong, not for a change of mind.';
    }
    hint('');
    // Free personalize: replaces the custom-price note above (own block so the
    // line above stays untouched). Keeps the standard return promise after it.
    if (mp && personalizeVariant) {
      mp.hidden = pageMode !== 'modify';
      mp.textContent = 'Adding a name is free, same price as this design. We remake or refund it if it arrives damaged or prints wrong, not for a change of mind.';
    }
    render();
    later(function () { (monoTopEl.value ? monoBotEl : monoTopEl).focus(); }, 60);
  }

  qa('.cd-modecard').forEach(function (b) {
    b.addEventListener('click', function () {
      setMode(b.dataset.mode);
      CA('modeSelected', b.dataset.mode);
      // No separate "choose a photo" button: the card IS the picker.
      if (b.dataset.mode === 'upload') fileEl.click();
    });
  });
  modebar.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    setMode(b.dataset.mode);
    CA('modeSelected', b.dataset.mode);
    // Same rule from the compact switcher, so there is never a choose button.
    if (b.dataset.mode === 'upload' && photoState === 'none') fileEl.click();
  });

  // ---- describe --------------------------------------------------------------
  var promptTimer = null, lastGuessed = '';
  if (promptEl) {
    promptEl.addEventListener('input', function () {
      clearTimeout(promptTimer);
      render();
      var text = (promptEl.value || '').trim();
      if (styleTouched || text.length < 6 || text.split(/\s+/).length < 2) return;
      if (text === lastGuessed) return;
      promptTimer = setTimeout(function () {
        lastGuessed = text;
        classifyInput({ prompt: text }).then(function () { showStyleBlock(true); render(); });
      }, 700);
    });
    promptEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); go(); }
    });
  }
  var examples = q('.cd-examples');
  if (examples) examples.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    promptEl.value = b.textContent;
    promptEl.dispatchEvent(new Event('input'));
    promptEl.focus();
  });
  var modExamples = q('.cd-modexamples');
  if (modExamples) modExamples.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    modnoteEl.value = b.textContent;
    render();
    modnoteEl.focus();
  });
  if (modnoteEl) {
    modnoteEl.addEventListener('input', render);
    modnoteEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) { e.preventDefault(); go(); }
    });
  }
  if (noteEl) noteEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && pendingFile) { e.preventDefault(); go(); }
  });

  // ---- upload ----------------------------------------------------------------
  if (fileEl) fileEl.addEventListener('change', function (e) {
    var f = (e.target.files && e.target.files[0]) || null;
    if (!f) return;
    if (f.size > MAX_UPLOAD_BYTES) {
      hint('That image is too large (max 15 MB).', 'err');
      fileEl.value = '';
      return;
    }
    pendingFile = f;
    if (photoURL) { try { URL.revokeObjectURL(photoURL); } catch (err) {} }
    photoURL = URL.createObjectURL(f);
    analyzePhoto(photoURL);
  });
  if (changeBtn) changeBtn.addEventListener('click', function () { fileEl.click(); });

  // Empty-slot picker. With no photo chosen the slot used to be a blank box, so a
  // customer who cancelled the phone's picker had no way back in. The whole slot
  // is one tappable button that opens the SAME file input (accept list unchanged).
  var pickBtn = null;
  (function () {
    var slot = q('.cd-photoslot');
    if (!slot || !fileEl) return;
    try {
      var st = document.createElement('style');
      st.textContent =
        '.cd-pickphoto{display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'gap:.55rem;width:100%;flex:1 1 auto;min-height:142px;box-sizing:border-box;padding:1rem;' +
        'border:2px dashed var(--cd-line2,#cdb9a0);border-radius:14px;background:var(--cd-surface2,#f6f1e8);' +
        'color:var(--cd-ink,inherit);font:inherit;font-size:1rem;font-weight:600;cursor:pointer;' +
        'touch-action:manipulation;-webkit-tap-highlight-color:transparent}' +
        '.cd-pickphoto:hover,.cd-pickphoto:focus-visible{border-color:var(--cd-accent,currentColor)}' +
        '.cd-pickphoto svg{width:34px;height:34px;color:var(--cd-accent,currentColor)}' +
        '.cd-pickphoto[hidden]{display:none}';
      document.head.appendChild(st);
    } catch (e) {}
    pickBtn = document.createElement('button');
    pickBtn.type = 'button';
    pickBtn.className = 'cd-pickphoto';
    pickBtn.hidden = true;
    pickBtn.setAttribute('aria-label', 'Choose a photo');
    pickBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M4 8h3l1.6-2.2h6.8L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>' +
      '<circle cx="12" cy="13.2" r="3.6"/></svg>' +
      '<span>Tap to choose a photo</span>';
    pickBtn.addEventListener('click', function () { fileEl.click(); });
    slot.insertBefore(pickBtn, slot.firstChild);
  })();

  function analyzePhoto(src) {
    photoState = 'loading';
    stage = 'analyzing';
    // The photo stays HIDDEN until the classifier answers: its appearance is the
    // "we can read this" signal. Showing it immediately made the wait look like
    // nothing was happening.
    show(photoWrap, false);
    show(changeBtn, false);
    showStyleBlock(false);
    show(photoLoad, true);
    cycle(photoMsg, PHOTO_MSGS, MSG_EVERY_MS);
    render();

    classifyInput({ file: pendingFile }).then(function (res) {
      clearTimers();
      show(photoLoad, false);
      if (!res.ok) {
        photoState = 'none';
        pendingFile = null;
        fileEl.value = '';
        stage = 'input';
        hint(res.error || 'That image didn’t work. Try another photo.', 'err');
        render();
        return;
      }
      photoState = 'ready';
      stage = 'input';
      photoImg.src = src;
      show(photoWrap, true);
      show(changeBtn, true);
      showStyleBlock(true);
      hint('');
      render();
    });
  }

  function cycle(el, msgs, every) {
    if (!el) return;
    var i = 0;
    el.textContent = msgs[0];
    (function step() {
      later(function () { i = (i + 1) % msgs.length; el.textContent = msgs[i]; step(); }, every);
    })();
  }

  // Shrink an oversized photo in the browser before upload. Small files (logos,
  // screenshots) pass through UNTOUCHED to preserve their exact bytes. Any
  // decode/encode failure falls back to the original, so this can never make an
  // upload fail that would otherwise have worked.
  function downscaleImage(file) {
    return new Promise(function (resolve) {
      if (!file || file.size <= UPLOAD_TARGET_BYTES) { resolve(file); return; }
      var done = false;
      function finish(out) { if (!done) { done = true; resolve(out || file); } }
      function drawFrom(src, w, h, cleanup) {
        try {
          var scale = Math.min(1, UPLOAD_MAX_EDGE / Math.max(w, h));   // only shrink
          var cw = Math.max(1, Math.round(w * scale));
          var ch = Math.max(1, Math.round(h * scale));
          var canvas = document.createElement('canvas');
          canvas.width = cw; canvas.height = ch;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff';            // JPEG has no alpha -> flatten onto white
          ctx.fillRect(0, 0, cw, ch);
          ctx.drawImage(src, 0, 0, cw, ch);
          if (cleanup) cleanup();
          canvas.toBlob(function (blob) {
            finish(blob && blob.size < file.size ? blob : file);
          }, 'image/jpeg', UPLOAD_JPEG_QUALITY);
        } catch (e) { if (cleanup) cleanup(); finish(file); }
      }
      function viaImg() {
        try {
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () {
            drawFrom(img, img.naturalWidth || img.width, img.naturalHeight || img.height,
                     function () { try { URL.revokeObjectURL(url); } catch (e) {} });
          };
          img.onerror = function () { try { URL.revokeObjectURL(url); } catch (e) {} finish(file); };
          img.src = url;
        } catch (e) { finish(file); }
      }
      // Prefer createImageBitmap: decodes off-thread and bakes in EXIF
      // orientation (canvas re-encoding strips the EXIF the server relies on).
      if (window.createImageBitmap) {
        var opts = {};
        try { opts.imageOrientation = 'from-image'; } catch (e) {}
        window.createImageBitmap(file, opts).then(function (bmp) {
          drawFrom(bmp, bmp.width, bmp.height, function () { try { bmp.close(); } catch (e) {} });
        }).catch(viaImg);
      } else { viaImg(); }
    });
  }

  // ---- generate / upload / modify -------------------------------------------
  function canGo() {
    if (stage !== 'input') return false;
    if (mode === 'describe') return (promptEl.value || '').trim().length > 2;
    if (mode === 'upload')   return photoState === 'ready';
    if (mode === 'modify')   return (modnoteEl.value || '').trim().length > 2;
    if (mode === 'personalize') {
      return !!(monoBase && ((monoTopEl.value || '').trim() || (monoBotEl.value || '').trim()));
    }
    return false;
  }

  function beginGenerating() {
    stage = 'generating';
    hideAllPanels();
    show(secGen, true);
    cycle(genMsg, mode === 'personalize' ? MONO_MSGS : GEN_MSGS,
          mode === 'personalize' ? 900 : MSG_EVERY_MS);
    render();
  }

  // What the customer typed for the current mode - the keyword check reads it.
  function typedText() {
    if (mode === 'describe') return (promptEl && promptEl.value) || '';
    if (mode === 'upload')   return (noteEl && noteEl.value) || '';
    if (mode === 'modify')   return (modnoteEl && modnoteEl.value) || '';
    return '';
  }
  // Why the offer should show, or '' if it should not.
  function bizReason() {
    if (!bizEl || bizSeen()) return '';
    if (BIZ_RE.test(typedText())) return 'keyword';
    // Classifier only for UPLOADS: typed words are also 'graphic' ("Merry
    // Christmas"), and for text the keyword check above is the better signal.
    if (lastClassGraphic && mode === 'upload') return 'classifier';
    return '';
  }
  function showBizOffer(via) {
    markBizSeen();
    stage = 'offer';
    clearTimers();
    hint('');
    hideAllPanels();
    bizEl.querySelector('.cd-biz-no').textContent =
      mode === 'describe' ? 'No — it’s just words' : 'No — it’s just for me';
    show(bizEl, true);
    if (body) body.scrollTop = 0;
    CA('track', 'biz_interstitial_shown', { via: via, mode: mode });
    render();
    later(function () { var b = bizEl.querySelector('.cd-biz-go'); if (b) b.focus(); }, 40);
  }
  if (bizEl) {
    bizEl.querySelector('.cd-biz-go').addEventListener('click', function () {
      CA('track', 'biz_interstitial_switch', { mode: mode });
      // Carry a typed description across; a photo cannot travel, so upload
      // customers pick theirs again on the logo page.
      var p = mode === 'describe' ? (promptEl.value || '').trim() : '';
      window.location.href = BIZ_URL + '?design=open' + (p ? '&prompt=' + encodeURIComponent(p) : '');
    });
    bizEl.querySelector('.cd-biz-no').addEventListener('click', function () {
      CA('track', 'biz_interstitial_dismiss', { mode: mode });
      stage = 'input';
      show(bizEl, false);
      dispatch();                            // carry on with exactly what they asked for
    });
  }

  function go() {
    if (!canGo()) return;
    // The cap exists to bound Gemini spend. Personalizing sets type from a font
    // and costs nothing, so it is neither blocked by the cap nor counted in it.
    if (mode !== 'personalize' && capReached()) { hint('You’ve reached the free design limit for now.', 'err'); return; }
    var why = bizReason();
    if (why) { showBizOffer(why); return; }
    dispatch();
  }
  function dispatch() {
    if (mode === 'describe') return runGenerate();
    if (mode === 'upload')   return runUpload();
    if (mode === 'modify')   return runModify();
    if (mode === 'personalize') return runPersonalize();
  }

  function fail(msg) {
    stage = 'input';
    clearTimers();
    hideAllPanels();
    if (mode === 'modify') { show(panModify, true); }
    else if (mode === 'personalize') { show(panPersonal, true); }
    else {
      show(modebar, true);
      show(panDesc, mode === 'describe');
      show(panUpload, mode === 'upload');
      showStyleBlock(true);
    }
    hint(msg, 'err');
    render();
  }

  function accept(j, label, usedStyle, from, mono, origin) {
    designs.push({
      design_id: j.design_id,
      design_url: j.design_url,
      preview_b64: j.preview_png_b64,
      cookie_b64: j.cookie_png_b64 || null,
      cookie_url: j.cookie_url || null,
      style: normStyle(usedStyle) || normStyle(j.category) || '',
      // the tile, not just the wire style: 'graphic' is Words on one page and
      // Business logo on another, and the record outlives the page it was made on
      // What the backend DREW wins over the tile that was pre-selected: a
      // text-only request ("just the text Happy Birthday") comes back
      // text_only + category 'graphic' whatever tile was pressed. The same wire
      // style keeps the tile the customer pressed (Words vs Business logo).
      tile: (j && j.text_only) ? resolveTile('text')
          : (normStyle(j && j.category) && normStyle(j.category) !== normStyle(usedStyle))
            ? resolveTile(j.category) : resolveTile(usedStyle || (j && j.category)),
      label: label || '',
      from: from || '',
      mono: mono || null,
      origin: origin || null     // how it was made, so Edit returns to THAT input
    });
    var idx = designs.length - 1;
    // Personalized stamps get the cookie photo too. It was skipped while that
    // image came from Gemini (which could misspell the name); since backend
    // PR #17 it is composited from the exact stamp, so the words cannot change.
    var needCookie = !designs[idx].cookie_b64 && !designs[idx].cookie_url;
    if (needCookie) designs[idx]._cookiePending = true;
    selected = idx;
    if (!mono) bumpCount();
    persist();
    // Both pictures, or neither. showResult() used to run the moment the stamp
    // arrived, so the customer watched an empty frame fill in beside it. Now the
    // loading screen stays up until renderCookie settles - it calls showResult()
    // itself when the cookie lands, and the two guards below cover the cases
    // where it never does. showResult() sets stage, so it is also the flag.
    if (!needCookie) { showResult(); return Promise.resolve(); }
    later(function () { if (stage !== 'result') showResult(); }, COOKIE_WAIT_MS);
    return renderCookie(idx).then(function () {
      if (stage !== 'result') showResult();   // cookie failed: show the stamp anyway
    });
  }

  function runGenerate() {
    var prompt = (promptEl.value || '').trim();
    var usedStyle = style;                    // capture: the row may change mid-request
    var attempt = CA('startAttempt', { style: usedStyle, mode: 'describe' }) || 0;
    beginGenerating();
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prompt: prompt, style: usedStyle,
        session_id: sessionId(), attempt_number: attempt
      })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      var j = res.body;
      if (!res.ok || !j.ok) { fail((j && j.error) || 'Something went wrong. Please try again.'); return; }
      return accept(j, prompt, usedStyle, '', null, { mode: 'describe', prompt: prompt });
    })
    .catch(function () { fail('Network error. Please try again.'); });
  }

  function runUpload() {
    var usedStyle = style;
    var note = noteEl ? (noteEl.value || '').trim() : '';
    var attempt = CA('startAttempt', { style: usedStyle, mode: 'upload', edited: !!note }) || 0;
    var file = pendingFile;
    var photoAt = photoURL;      // the photo this design came from, while it is still loaded
    beginGenerating();
    downscaleImage(file).then(function (blob) {
      var form = new FormData();
      form.append('image', blob, file.name || 'upload');
      form.append('style', usedStyle);
      if (sessionId()) form.append('session_id', sessionId());
      form.append('attempt_number', String(attempt));
      if (note) form.append('instructions', note);
      return fetch(endpoint, { method: 'POST', body: form })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          var j = res.body;
          if (!res.ok || !j.ok) {
            fail((j && j.error) || 'That image didn’t work. Try a clearer photo.');
            return;
          }
          return accept(j, note || 'Your photo, redrawn', usedStyle, '', null,
                        { mode: 'upload', note: note, photo: photoAt });
        });
    })
    .catch(function () { fail('Network error uploading your image.'); });
  }

  function runModify() {
    var note = (modnoteEl.value || '').trim();
    var usedStyle = style;
    var base = modBase;
    var attempt = CA('startAttempt', { style: usedStyle, mode: 'modify', own: !!base.own }) || 0;
    beginGenerating();
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        modify_from: base.id, instructions: note, style: usedStyle,
        session_id: sessionId(), attempt_number: attempt
      })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      var j = res.body;
      if (!res.ok || !j.ok) { fail((j && j.error) || 'We couldn’t make that change. Try wording it differently.'); return; }
      return accept(j, note, usedStyle, base.own ? '' : base.title, null,
                    { mode: 'modify', base: base });
    })
    .catch(function () { fail('Network error. Please try again.'); });
  }

  function runPersonalize() {
    var top = (monoTopEl.value || '').trim();
    var bottom = (monoBotEl.value || '').trim();
    var base = monoBase;
    var attempt = CA('startAttempt', { style: 'graphic', mode: 'monogram' }) || 0;
    beginGenerating();
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        monogram: { art_id: base.art_id, top: top, bottom: bottom },
        session_id: sessionId(), attempt_number: attempt
      })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      var j = res.body;
      if (!res.ok || !j.ok) { fail((j && j.error) || 'We couldn\u2019t set those words. Please try again.'); return; }
      return accept(j, [j.top, j.bottom].filter(Boolean).join(' \u00b7 '), 'text', base.from || '',
                    { top: j.top || '', bottom: j.bottom || '', base: base });
    })
    .catch(function () { fail('Network error. Please try again.'); });
  }

  // Render the baked-cookie mockup so the customer gets BOTH images from one
  // click. Best-effort: a cookie failure never costs them the design.
  function renderCookie(idx) {
    var x = designs[idx];
    if (!x || x.cookie_b64 || x.cookie_url) return Promise.resolve();
    x._cookiePending = true;
    if (selected === idx) figLoading(cookieFig, true);
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ design_id: x.design_id })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
    .then(function (res) {
      var j = res.body;
      if (!res.ok || !j.ok) return;
      x.cookie_b64 = j.cookie_png_b64 || null;
      x.cookie_url = j.cookie_url || null;
    })
    .catch(function () { /* best-effort */ })
    .then(function () {
      x._cookiePending = false;
      persist();
      if (selected !== idx) return;
      if (x.cookie_b64 || x.cookie_url) showResult();
      else { figLoading(cookieFig, false); show(cookieFig, false); }
    });
  }

  function showResult() {
    clearTimers();
    stage = 'result';
    var x = designs[selected];
    if (!x) return;
    // The footer ("Change the words", "Change something else") and the feedback
    // retry act on `mode`, so it has to follow the design on screen - picking an
    // older thumbnail used to leave it on whatever was used last.
    if (x.mono) mode = 'personalize';
    else if (x.origin && x.origin.mode === 'modify' && x.origin.base) { mode = 'modify'; modBase = x.origin.base; }
    else if (x.origin && x.origin.mode) mode = x.origin.mode;
    // Drop the generating-stage hint ("this takes about N seconds") now that it
    // is done, but never stomp the "added to cart" confirmation: renderCookie
    // calls back in here when the baked image lands, which can be after an add.
    if (hintEl && !hintEl.classList.contains('cd-good')) hint('');
    hideAllPanels();
    show(secResult, true);
    setImg(artImg, stampFig, designSrc(x));
    if (x.cookie_b64 || x.cookie_url) {
      show(cookieFig, true);
      setImg(cookieImg, cookieFig, cookieSrc(x));
    } else if (x._cookiePending) {
      show(cookieFig, true);
      cookieImg.removeAttribute('src');
      figLoading(cookieFig, true);
    } else {
      show(cookieFig, false);
    }
    if (capStyle) capStyle.textContent = x.mono ? '— personalized'
                                     : x.from ? '— from ' + x.from
                                     : (designLabel(x) ? '— ' + designLabel(x) : '');
    if (editTxt) editTxt.textContent = x.label ? '“' + x.label + '”' : '';
    // one picture, centred - only if the cookie photo is not coming
    secResult.classList.toggle('cd-monoresult',
      !!x.mono && !(x.cookie_b64 || x.cookie_url || x._cookiePending));
    show(monoConfirm, !!x.mono);
    show(packEl, packMode && !x.mono);
    if (monoOk) monoOk.checked = !!x.confirmed;
    if (monoConfirm) monoConfirm.classList.toggle('cd-todo', !!x.mono && !x.confirmed);
    // Only on a finished picture: words around a design that already has curved
    // words would shrink the first set below what carves.
    show(addWordsBtn, !x.mono && !!panPersonal);
    show(changeItBtn, !x.mono && !!panModify);
    // On a stamp with words, Edit changes the PICTURE (the footer button already
    // changes the words) - but only when that picture is a design in the tray.
    if (editBtn) editBtn.textContent = !x.mono ? 'Edit'
      : (findDesign(x.mono.base && x.mono.base.art_id) >= 0 ? 'Change the picture' : 'Edit words');
    setStepLabels(x.mono ? 'personalize' : (x.from ? 'modify' : 'design'));
    renderTray();
    if (body) body.scrollTop = 0;
    CFB(x.design_id, x.style);
    render();
  }

  // ---- the tray: always visible once there's something in it -----------------
  function renderTray() {
    if (lastOnThisPage() < 0) { show(tray, false); return; }
    show(tray, true);
    thumbsEl.innerHTML = designs.map(function (x, i) {
      if (!onThisPage(x)) return '';
      var n = addedCounts[x.design_id] || 0;
      return '<button type="button" data-i="' + i + '" aria-pressed="' + (i === selected) +
             '" aria-label="Design ' + (i + 1) + '">' +
             '<img src="' + designSrc(x) + '" alt="">' +
             (n > 0 ? '<span class="cd-tick">✓</span>' : '') +
             '</button>';
    }).join('');
  }
  thumbsEl.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    clearTimers();
    selected = parseInt(b.dataset.i, 10);
    CA('reselected', designs[selected] && designs[selected].design_id);
    hint('');
    showResult();
  });
  if (newTile) newTile.addEventListener('click', startFresh);

  // ---- footer ----------------------------------------------------------------
  if (editBtn) editBtn.addEventListener('click', function () {
    var x = designs[selected];
    if (x && x.mono && x.mono.base) {
      var src = findDesign(x.mono.base.art_id);
      if (src >= 0) {                         // change the picture under the words
        selected = src;
        CA('track', 'monogram_change_picture', { design_id: x.design_id });
        editDesign(designs[src]);
        return;
      }
      // back to the words, as they were
      startPersonalize(x.mono.base, { top: x.mono.top, bottom: x.mono.bottom });
      return;
    }
    editDesign(x);
  });

  // Edit returns to the input that made THIS design. It used to reopen whichever
  // panel was used last, so an older thumbnail's Edit could show another
  // design's photo or words.
  function editDesign(x) {
    if (!x) return;
    var o = x.origin || {};
    var label = '';
    if (o.mode === 'modify' && o.base) { startModify(o.base, x.label || ''); return; }
    if (o.mode === 'describe') {
      promptEl.value = o.prompt || x.label || '';
      lastGuessed = (promptEl.value || '').trim();
      setMode('describe');
    } else if (o.mode === 'upload' && o.photo && o.photo === photoURL && photoState === 'ready') {
      if (noteEl) noteEl.value = o.note || '';
      setMode('upload');
    } else if (x.from && pageMode === 'modify') {
      startModify(pageBase, x.label || '');   // a ready-made change from before this was tracked
      return;
    } else {
      // The photo is no longer loaded (another was picked, or the page changed),
      // or the design predates this: the one thing we can still offer is a change.
      startModify(ownBase(x), '');
      return;
    }
    setStyle(x.tile || x.style);
    label = tileLabel(tile);
    if (label && detectedEl) detectedEl.innerHTML = 'This design used <b>' + label + '</b>. Tap another to change it.';
    showStyleBlock(true);
    render();
  }

  if (changeItBtn) changeItBtn.addEventListener('click', function () {
    var x = designs[selected];
    if (!x) return;
    CA('track', 'change_something_open', { design_id: x.design_id });
    startModify(ownBase(x), '');
  });

  if (nameTip) nameTip.querySelector('button').addEventListener('click', function () {
    var t = (modnoteEl && modnoteEl.value) || '';
    var words = guessWords(t);
    var onTop = /\b(top|above|over)\b/i.test(t) && !/\b(bottom|below|under)\b/i.test(t);
    CA('track', 'change_to_words', { design_id: modBase.id });
    startPersonalize({ art_id: modBase.id, url: modBase.url,
                       title: modBase.own ? 'your design' : modBase.title,
                       from: modBase.own ? '' : modBase.title },
                     { top: onTop ? words : '', bottom: onTop ? '' : words });
  });

  if (panPersonal) panPersonal.querySelector('.cd-monoback').addEventListener('click', function () {
    var i = monoBase ? findDesign(monoBase.art_id) : -1;
    if (i < 0) return;
    selected = i;
    showResult();
  });
  if (modBackBtn) modBackBtn.addEventListener('click', function () {
    var i = modBase.own ? findDesign(modBase.id) : -1;
    if (i < 0) return;
    selected = i;
    showResult();
  });
  if (addWordsBtn) addWordsBtn.addEventListener('click', function () {
    var x = designs[selected];
    if (!x) return;
    CA('track', 'monogram_add_words', { design_id: x.design_id });
    startPersonalize({ art_id: x.design_id, url: x.design_url || designSrc(x),
                       title: 'your design',
                       from: x.from ? x.from + ' (modified)' : '' },
                     { top: '', bottom: '' });
  });
  if (monoOk) monoOk.addEventListener('change', function () {
    var x = designs[selected];
    if (x) x.confirmed = monoOk.checked;
    monoConfirm.classList.toggle('cd-todo', !monoOk.checked);
    hint('');
    render();
  });
  if (secondary) secondary.addEventListener('click', function () {
    var x = designs[selected];
    if (stage === 'result' && x && x.mono && x.mono.base) {   // "Change the words"
      startPersonalize(x.mono.base, { top: x.mono.top, bottom: x.mono.bottom });
      return;
    }
    if (mode === 'modify' && modBase.own) { startFresh(); return; }
    backToInput(true);
  });
  primary.addEventListener('click', function () {
    if (stage === 'result') addToCart();
    else go();
  });

  function backToInput(clear) {
    if (mode === 'personalize') {             // "Change the words": keep what they typed
      var cur = designs[selected];
      if (cur && cur.mono && cur.mono.base) {
        startPersonalize(cur.mono.base, { top: cur.mono.top, bottom: cur.mono.bottom });
      } else {
        startPersonalize(null, null);
      }
      return;
    }
    stage = 'input';
    clearTimers();
    hint('');
    hideAllPanels();
    if (mode === 'modify') {
      show(panModify, true);
      if (clear) modnoteEl.value = '';
      render();
      later(function () { modnoteEl.focus(); }, 30);
      return;
    }
    show(modebar, true);
    show(panDesc, mode === 'describe');
    show(panUpload, mode === 'upload');
    showStyleBlock(mode === 'upload' ? photoState === 'ready' : !clear);
    if (clear && mode === 'describe') { promptEl.value = ''; lastGuessed = ''; }
    render();
    if (mode === 'describe') later(function () { promptEl.focus(); }, 30);
  }

  function render() {
    if (pickBtn) show(pickBtn, mode === 'upload' && photoState === 'none');
    var modifying = mode === 'modify';
    var personal = mode === 'personalize';

    // The business offer carries its own two buttons; the footer steps aside.
    show(primary, stage !== 'offer');
    if (stage === 'offer') {
      show(secondary, false);
      setStep(2);
      return;
    }
    if (stage === 'generating') {
      primary.disabled = true;
      primary.textContent = personal ? 'Setting your words…'
                          : modifying ? 'Making your version…' : 'Making your design…';
      show(secondary, false);
      setStep(3);
      // Measured 10-01: typed designs ~15 s, photos 35-60 s. Changes to a
      // finished design are unmeasured, so they keep the old 20.
      hint(personal ? 'Just a moment.'
         : mode === 'upload' ? 'Photos take about 45 seconds. Hang tight.'
         : mode === 'describe' ? 'This takes about 15 seconds.'
         : 'This takes about 20 seconds.');
      return;
    }
    if (stage === 'analyzing') {
      primary.disabled = true;
      primary.textContent = 'Reading your photo…';
      show(secondary, false);
      setStep(1);
      return;
    }
    if (stage === 'result') {
      var x = designs[selected];
      // a personalized stamp waits for the spelling box
      primary.disabled = !!(x.mono && !x.confirmed);
      primary.textContent = (x.mono && !x.confirmed) ? 'Tick the box above to add to cart'
                          : (addedCounts[x.design_id] ? 'Add again' : 'Add to cart') +
                            (priceNow() ? ' · ' + priceNow() : '');
      show(secondary, true);
      secondary.textContent = x.mono ? 'Change the words'
                            : (modifying && !modBase.own) ? 'Change something else' : 'Make another design';
      setStep(3);
      return;
    }
    show(secondary, false);
    if (personal) {
      primary.disabled = !canGo();
      primary.textContent = 'Preview my stamp';
      setStep(canGo() ? 2 : 1);
      return;
    }
    if (modifying) {
      checkNameTip();
      primary.disabled = !canGo();
      primary.textContent = 'Create my version';
      setStep(canGo() ? 2 : 1);
      return;
    }
    if (!mode) {
      primary.disabled = true;
      primary.textContent = 'Create my design';
      setStep(1);
      return;
    }
    primary.disabled = !canGo();
    primary.textContent = 'Create my design';
    // single-tile pages never open the style block, so step on readiness instead
    setStep(singleTile ? (canGo() ? 2 : 1) : (styleBlock.hidden ? 1 : 2));
  }

  // ---- cart ------------------------------------------------------------------
  // A design made in this popup ALWAYS carts against the custom-disc variant,
  // even when the popup was opened from a ready-made product page: the art has a
  // brand-new design_id, so a line on the "Dog Cookie Stamp" variant would show
  // that title next to different artwork.
  function variantId() {
    // Free personalize: keyed on the designer mode (what the customer is doing
    // right now), not pageMode, so "Modify" (AI changes) still carts as custom.
    if (mode === 'personalize' && personalizeVariant) return Number(personalizeVariant);
    // A personalized product carts as a custom disc too: priced as one, and the
    // line must not carry the product's title next to someone's own words.
    if ((pageMode === 'modify' || pageMode === 'personalize') && customVariant) return Number(customVariant);
    // A monogram made on a pack page still carts against the chosen pack; the
    // chooser is hidden for it, so it keeps whatever was selected (6 by default).
    if (packMode && pack) return Number(pack.id);
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return Number(m[1]);
    if (d.variant && d.variant !== '0') return Number(d.variant);
    var sel = document.querySelector(
      'form[action*="/cart/add"] [name="id"], product-form [name="id"], [name="id"]');
    if (sel && sel.value) return Number(sel.value);
    return null;
  }

  // Tell Horizon the cart changed. Its header icon (assets/cart-icon.js) listens
  // for 'cart:update' on document and takes the new count from
  // detail.data.itemCount - the same event its own product form fires. A source
  // other than 'product-form-component' makes it SET the count rather than add
  // to it, so the number is always the cart's real total. This store uses the
  // cart PAGE (cart_type: page), so no drawer opens.
  function refreshThemeCartEvent(cart, source) {
    try {
      if (!cart || typeof cart.item_count !== 'number') return;
      var ev;
      try { ev = new Event('cart:update', { bubbles: true }); }
      catch (e) { ev = document.createEvent('Event'); ev.initEvent('cart:update', true, false); }
      ev.detail = { resource: cart, sourceId: source,
                    data: { source: source, itemCount: cart.item_count } };
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function refreshThemeCart(cart) { refreshThemeCartEvent(cart, 'cookie-designer'); }

  function addToCart() {
    if (selected < 0) return;
    var vid = variantId();
    if (!vid) { hint('Could not find the product on this page.', 'err'); return; }
    var x = designs[selected];
    if (!onThisPage(x)) { hint('That design belongs to a different stamp. Make a new one here.', 'err'); return; }
    if (x.mono && !x.confirmed) { hint('Please tick the spelling box first.', 'err'); return; }
    primary.disabled = true;
    hint('Adding to your cart…');
    var props = {
      '_design_id': x.design_id,
      '_design_url': x.design_url,
      'Design': x.mono ? ((x.from || 'Your design') + ' (personalized)')
              : x.from ? (x.from + ' (modified)') : x.design_url
    };
    if (x.mono) {
      // visible on the order, so the packer can read the words off the slip
      if (x.mono.top) props['Top line'] = x.mono.top;
      if (x.mono.bottom) props['Bottom line'] = x.mono.bottom;
      props['Style'] = 'Personalized';
    } else if (x.style) props['Style'] = designLabel(x) || x.style;
    if (x.cookie_url) props['_cookie_url'] = x.cookie_url;
    var sp = CA('cartProps', x.design_id);
    if (sp) Object.keys(sp).forEach(function (k) { if (!(k in props)) props[k] = sp[k]; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
    })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
    .then(function (res) {
      if (!res.ok) {
        hint((res.body && (res.body.description || res.body.message)) ||
             ('Could not add to cart (' + res.status + ').'), 'err');
        primary.disabled = false;
        return;
      }
      // VERIFY it landed - add.js can return 200 yet not persist.
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          primary.disabled = false;
          if (cart && cart.item_count > 0) {
            addedCounts[x.design_id] = (addedCounts[x.design_id] || 0) + 1;
            CA('addedToCart', x.design_id, x.style);   // only after the cart is VERIFIED
            refreshThemeCart(cart);
            renderTray();
            persist();
            render();
            hint('✓ Added — ' + cart.item_count + ' item' +
                 (cart.item_count > 1 ? 's' : '') + ' in your cart.', 'good');
          } else {
            hint('The item did not stay in the cart — check inventory or price.', 'err');
          }
        });
    })
    .catch(function () { primary.disabled = false; hint('Network error adding to cart.', 'err'); });
  }

  // ---- hook used by cookie-feedback.js's "Send & try again" ------------------
  // A thumbs-down comment is the single most useful sentence in the session:
  // it is a better prompt than the one that produced the bad design. This lets
  // the feedback widget fold it straight into a re-run.
  window.CookieDesigner = {
    retryWith: function (text) {
      text = (text || '').trim();
      if (!text) return false;
      if (mode === 'personalize') return false;   // nothing free-text to fold it into
      if (mode === 'modify') {
        modnoteEl.value = (modnoteEl.value + ' — ' + text).trim();
      } else if (mode === 'upload') {
        noteEl.value = text;
      } else {
        promptEl.value = ((promptEl.value || '') + ', ' + text).replace(/^,\s*/, '');
        lastGuessed = '';
      }
      backToInput(false);
      return true;
    },
    isOpen: function () { return !modal.hidden; }
  };

  // ---- startup ---------------------------------------------------------------
  restore();
  startFresh();
  selected = lastOnThisPage();
  renderTray();

  // Deep link: /products/...?design=open lands with the popup already open, so a
  // homepage or email CTA can drop someone straight into the designer.
  if (/[?&]design=open\b/.test(window.location.search)) {
    openModal(pageMode === 'personalize' ? 'personalize' : '');
    // ?prompt= comes from the business offer on the consumer page: land the
    // customer in Describe with what they already typed, so they retype nothing.
    var pm = window.location.search.match(/[?&]prompt=([^&]*)/);
    var carried = '';
    try { carried = pm ? decodeURIComponent(pm[1].replace(/\+/g, ' ')).trim().slice(0, 500) : ''; } catch (e) {}
    if (carried && pageMode === 'design') {
      setMode('describe');
      promptEl.value = carried;
      promptEl.dispatchEvent(new Event('input'));
    }
  }
})();
